/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { forwardRef, useState } from 'react';
import {
  EditingState,
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  SearchPanel,
  Toolbar,
  DragDropProvider,
  Table,
  TableColumnResizing,
  TableColumnVisibility,
  ColumnChooser,
  PagingPanel,
} from '@devexpress/dx-react-grid-material-ui';
import {
  currencyFormatter,
  attachmentsFormatter,
  opTypeFormatter,
  timeFormatter,
} from '../../Shared/colorFormat';
import { SearchTable } from '../../components';
import { Button, Typography } from '@material-ui/core';
import { TableComponent } from '../../Shared/TableComponent';
import { useOperationFinances, useTemplate } from '../../hooks';
import { getRowId } from '../../common';

const PendingFinance = forwardRef((props: any, ref: any) => {
  const { isRTL, words, start, end, type } = props;

  const [columns] = useState([
    { name: 'time', title: words?.time },
    { name: 'opType', title: isRTL ? 'العملية' : 'Document' },
    { name: 'total', title: isRTL ? 'المجموع' : 'Total' },
    { name: 'discount', title: words?.discount },
    { name: 'amount', title: words?.amount },
    { name: 'customerName', title: words?.customer },
    { name: 'supplierName', title: words?.supplier },
    { name: 'action', title: words?.action },
  ]);

  const [tableColumnExtensions]: any = useState([
    { columnName: 'time', width: 150 },
    { columnName: 'opType', width: 200 },
    { columnName: 'total', width: 150 },
    { columnName: 'discount', width: 150 },
    { columnName: 'amount', width: 150 },
    { columnName: 'customerName', width: 250 },
    { columnName: 'supplierName', width: 250 },
    { columnName: 'action', width: 150 },
  ]);

  const [tableColumnVisibilityColumnExtensions] = useState([
    { columnName: 'createdAt', togglingEnabled: false },
  ]);

  const { operationfinances, addOperationFinance } = useOperationFinances({
    start,
    end,
    type: type?.value,
  });

  const { tempoptions } = useTemplate();

  return (
    <Grid rows={operationfinances} columns={columns} getRowId={getRowId}>
      <SortingState />
      <EditingState onCommitChanges={() => null} />
      <SearchState />
      <PagingState defaultCurrentPage={0} defaultPageSize={50} />
      <IntegratedSorting />
      <IntegratedFiltering />
      <IntegratedPaging />
      <DragDropProvider />
      <Table
        messages={{
          noData: isRTL ? 'لا يوجد بيانات' : 'no data',
        }}
        tableComponent={TableComponent}
        rowComponent={(props: any) => (
          <Table.Row {...props} style={{ height: 40 }}></Table.Row>
        )}
        columnExtensions={tableColumnExtensions}
      />

      <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />

      <TableHeaderRow
        showSortingControls
        titleComponent={({ children }) => {
          return (
            <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
              {children}
            </Typography>
          );
        }}
      />
      <TableColumnVisibility
        columnExtensions={tableColumnVisibilityColumnExtensions}
        defaultHiddenColumnNames={[]}
      />
      <DataTypeProvider
        for={['time']}
        formatterComponent={timeFormatter}
      ></DataTypeProvider>
      <DataTypeProvider
        for={['opType']}
        formatterComponent={opTypeFormatter}
      ></DataTypeProvider>
      <DataTypeProvider
        for={['total', 'discount', 'amount']}
        formatterComponent={currencyFormatter}
      ></DataTypeProvider>
      <DataTypeProvider
        for={['attachments']}
        formatterComponent={attachmentsFormatter}
      ></DataTypeProvider>
      <DataTypeProvider
        for={['action']}
        formatterComponent={({ row }) => {
          return (
            <Button
              onClick={() => {
                addOperationFinance({ variables: { _id: row?._id } });
              }}
              style={{ height: 25, fontSize: 12 }}
              variant="contained"
              color="primary"
            >
              {isRTL ? 'اضافة القيود' : 'Add Entries'}
            </Button>
          );
        }}
      ></DataTypeProvider>

      <Toolbar
        rootComponent={(props: any) => (
          <Toolbar.Root
            style={{
              position: 'absolute',
              left: isRTL ? 40 : undefined,
              right: isRTL ? undefined : 40,
              top: 62,
              zIndex: 115,
            }}
            {...props}
          ></Toolbar.Root>
        )}
      />
      <ColumnChooser />
      <PagingPanel
        pageSizes={tempoptions?.pageall ? [5, 10, 20, 50, 0] : [5, 10, 20, 50]}
      />
      <SearchPanel
        inputComponent={(props: any) => {
          return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
        }}
      />
    </Grid>
  );
});

export default PendingFinance;
